import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigTituloPaginasService } from '@appNeo/core/services/config-titulo-paginas.service';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';

@Component({
  selector: 'neo-bloque-financiacion',
  templateUrl: './bloque-financiacion.component.html',
  styleUrls: ['./bloque-financiacion.component.scss']
})
export class BloqueFinanciacionComponent implements OnInit {

  precargaFinanciacionEntidades;
  @Input('elementos') elementos: any[] = [];
  constructor(
    private helpersService: HelpersService,
    private edicionSeccionesService: EdicionSeccionesService,
    private route: ActivatedRoute,
    private confTitulo: ConfigTituloPaginasService,
    private router: Router,
    private preferenciasService: PreferenciasService,
    private auxiliarService: AuxiliarService
  ) {
    this.route.data.subscribe(
      response => {
        // this.precargarOeTop = response.seccionesEditables.oe_top;
        this.precargaFinanciacionEntidades = response.seccionEditables?.financiacion_entidades;
        console.log('Financiacion entidades ', this.precargaFinanciacionEntidades);
        // this.precargaMeta = response.seccionesEditables.precargaMeta;
      }
    );
  }


  ngOnInit(): void {
    this.iniciarPagina();
  }

  iniciarPagina() {
    if (this.helpersService.hayModulo('edicion')) {
      // **********************************
      // Titulo y meta
      // **********************************
      // this.confTitulo.establecerTitulo('Otros eventos', 'oe-meta', this.precargaMeta, 'meta-tit');
      // this.confTitulo.establecerMeta(environment.descripcionMetaDefecto, 'oe-meta', this.precargaMeta, 'meta-des');
      // this.edicionSeccionesService.getContenidoBloquesSubseccion('oe-top').subscribe(data => {
      // this.precargarOeTop.elementos.forEach((elemento, index) => {
      //   let indice = (this.precargarOeTop.multiple) ? index : -1;
      //   this.top_titulo = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'oe-top-tit', indice);
      //     this.top_texto = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'oe-top-txt', indice);
      //     return;
      //   });
      // });
      // this.edicionSeccionesService.getContenidoBloquesSubseccion('oe-eventos').subscribe(data => {
      this.precargaFinanciacionEntidades?.elementos.forEach((elemento, index) => {
        let indice = (true) ? index : -1;
        let bloque = {
          tit: this.edicionSeccionesService.getCamposEdicionItem(elemento, 'entidad-tit', indice),
          txt: this.edicionSeccionesService.getCamposEdicionItem(elemento, 'entidad-txt', indice),
          img: this.edicionSeccionesService.getCamposEdicionItem(elemento, 'entidad-img', indice),
          imgMultiple: this.edicionSeccionesService.getCamposEdicionItem(elemento, 'entidad-img-multiple', indice),
          adjunto: this.edicionSeccionesService.getCamposEdicionItem(elemento, 'entidad-adjunto', indice),
          adjuntoMultiple: this.edicionSeccionesService.getCamposEdicionItem(elemento, 'entidad-adjunto-multiple', indice),

        };
        this.elementos.push(bloque);
      });
      // });
    }
  }
}
